module.exports = __webpack_public_path__ + "img/story_img4.7e218fb9.jpg";